// We use the USER_SRP_AUTH flow type because it is the most secure flow type.
// however when migrating users from one user pool to another, we need to use the USER_PASSWORD_AUTH flow type.
// As this will most likely be sone in stages, we need to be able to change the flow type dynamically.
// For this reason the AUTHENTICATION_FLOW_TYPE is a value that can be configured by environment.
// https://docs.amplify.aws/react/frontend/auth/switching-authentication-flows/
const COGNITO = {
  develop: {
    Auth: {
      REGION: 'us-west-2',
      USER_POOL_ID: 'us-west-2_6muGdsKW7',
      APP_CLIENT_ID: '2spgm4spigd4nkgss20d8at0e2',
      AUTHENTICATION_FLOW_TYPE: 'USER_PASSWORD_AUTH',
    },
  },
  staging: {
    Auth: {
      REGION: 'us-west-2',
      USER_POOL_ID: 'us-west-2_XHP55nas3',
      APP_CLIENT_ID: '6nptii12amhch6pjumc771iq2a',
      AUTHENTICATION_FLOW_TYPE: 'USER_PASSWORD_AUTH',
    },
  },
  production: {
    Auth: {
      REGION: 'us-west-2',
      USER_POOL_ID: 'us-west-2_F780PZz6B',
      APP_CLIENT_ID: '2li68vcdmu4ha4u02u0i4ob1pe',
      AUTHENTICATION_FLOW_TYPE: 'USER_PASSWORD_AUTH',
    },
  },
};

export default COGNITO[process.env.REACT_APP_API_ENV];
